import { CircularProgress, Typography, Box, useTheme } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const CircularProgressWithLabel = ({ value }: { value: number }) => {
  const theme = useTheme();
  const isComplete = value >= 100;
  
  // Calculate color based on completion percentage
  const getColor = () => {
    if (isComplete) return theme.palette.success.main;
    if (value > 75) return theme.palette.success.light;
    if (value > 50) return theme.palette.warning.main;
    if (value > 25) return theme.palette.warning.light;
    return theme.palette.error.main;
  };

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {isComplete ? (
        <Box 
          sx={{ 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <CheckCircleOutlineIcon 
            sx={{ 
              fontSize: "2.5em", 
              color: theme.palette.success.main,
              filter: 'drop-shadow(0px 2px 3px rgba(0,0,0,0.2))'
            }} 
          />
        </Box>
      ) : (
        <Box 
          sx={{ 
            position: 'relative',
            display: 'inline-flex'
          }}
        >
          <CircularProgress
            variant="determinate"
            value={value}
            size={60}
            thickness={4}
            sx={{ 
              color: getColor(),
              '& .MuiCircularProgress-circle': {
                strokeLinecap: 'round',
              }
            }}
          />
          <Box
            sx={{
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              position: 'absolute',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography
              variant="caption"
              component="div"
              sx={{ 
                fontWeight: 'bold',
                fontSize: '0.9rem',
                color: 'text.secondary'
              }}
            >
              {`${Math.round(value)}%`}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default CircularProgressWithLabel;
